import { type InputHTMLAttributes, forwardRef } from 'react'

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string
  error?: string
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ label, error, className = '', ...props }, ref) => {
    return (
      <div className="w-full">
        {label && (
          <label className="block text-lg font-medium text-[var(--color-text)] mb-2">
            {label}
          </label>
        )}
        <input
          ref={ref}
          className={`
            block w-full px-4 py-4
            text-lg
            bg-white/40 backdrop-blur-md
            border-0 rounded-xl
            text-[var(--color-text)]
            placeholder:text-[var(--color-text-light)]
            focus:outline-none focus:ring-2 focus:ring-[var(--color-primary)]
            shadow-sm
            transition-all duration-200
            min-h-[56px]
            ${error ? 'ring-2 ring-[var(--color-error)]' : ''}
            ${className}
          `}
          {...props}
        />
        {error && (
          <p className="mt-2 text-sm text-[var(--color-error)]">{error}</p>
        )}
      </div>
    )
  }
)

Input.displayName = 'Input'
